import { action } from 'mobx';
import API from '@util/ApiUtil';
import { YberStatus } from '@config/YberConfig';

export const YBER_BASE_URL = '/yber';

export default class YberApi {
  private static async getResult(url: string): Promise<YberStatus> {
    const result = await API.get(url);
    return result.data;
  }

  @action
  public static getStatus = (): Promise<YberStatus> => {
    return YberApi.getResult(`${YBER_BASE_URL}/status`);
  };
}
